import EnvConfig from 'env.config';
import { getStorageValue, setStorageSetting } from 'common/storage';
import defaultLanguageMessages from 'assets/lang/en.json';

const availableLanguages = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'zh', 'zh-hant'];

const localeFallbacks = [
  { locale: 'zh-cnt', resolveTo: 'zh-hant' },
  { locale: 'zh-hk', resolveTo: 'zh-hant' },
  { locale: 'zh-mo', resolveTo: 'zh-hant' },
  { locale: 'zh-tw', resolveTo: 'zh-hant' }
];

const createLanguagePath = key => `assets/lang/${ key }.json`;

export const defaultLanguage = {
  key: 'en',
  value: 'English',
  messages: defaultLanguageMessages
};

export function detectLocale(supportedLanguages) {
  let locale = getStorageValue('locale', null);
  if (locale != null) {
    return locale;
  }

  if (navigator.cookieEnabled && document.cookie.indexOf(EnvConfig.localeCookieName) > -1) {
    const cookieValue = document.cookie.split(`${ EnvConfig.localeCookieName }=`).pop().split(';')[0];
    if (cookieValue && cookieValue !== 'undefined') {
      locale = cookieValue;
      return locale;
    }
  }

  locale = navigator.language || navigator.userLanguage;

  if (localeFallbacks.some(e => e.locale === locale.toLowerCase())) {
    locale = localeFallbacks.filter(x => x.locale.toLowerCase() === locale.toLowerCase())[0].resolveTo;
  }

  if (supportedLanguages && supportedLanguages.length > 0) {
    const specificLanguage = supportedLanguages.find(l => l.key.toLowerCase() === locale.toLowerCase());
    const fallbackLanguage = supportedLanguages.find(l => l.key.toLowerCase() === locale.toLowerCase().split('-')[0]);

    locale = specificLanguage?.key ?? fallbackLanguage?.key;
  }

  return availableLanguages.includes(locale) ? locale : defaultLanguage.key;
}

export async function getSupportedLanguages() {
  const response = await fetch('./assets/lang/languages.json');
  if (!response.ok) {
    return [defaultLanguage];
  }

  let languages = await response.json();
  languages = languages.filter(x => availableLanguages.includes(x.key));
  if (!languages.some(x => x.key === defaultLanguage.key)) {
    languages.unshift(...defaultLanguage);
  }

  return languages;
}

export function saveLocale(locale) {
  if (navigator.cookieEnabled) {
    document.cookie = `${ EnvConfig.localeCookieName }=${ locale }; path=/; samesite=lax; secure`;
  }
  setStorageSetting('locale', locale);
  document.documentElement.setAttribute('lang', locale);
}

export async function getShortDictionary(locale) {
  const path = createLanguagePath(locale);
  const response = await fetch(path);
  if (!response.ok) {
    return {};
  }

  const dictionary = await response.json();
  return dictionary ?? {};
}
